import moment from 'moment';
import { ToggleButton } from 'vue-js-toggle-button';

if($('.page-pricing #pricing').length){
    var app = new Vue({
        el: '#pricing',
        data: {
            monthly:true,
            soloModal:false,
            coreModal:false,
            proModal:false,
            individualModal:false,
            corporateModal:false,
            userIp:userIp,
            sessionId:null,
            stripe:stripe,
            currency:'usd',
            individualPrice:null,
            corporatePrice:null,
            soloPrice:null,
            corePrice:null,
            proPrice:null,
            redirect:redirect,
            subscriptionRequestedType:subscriptionRequestedType,
            subscriptionRequestedPeriod:subscriptionRequestedPeriod,
            subscriptionRequestedCurrency:subscriptionRequestedCurrency,
            hasAccount:hasAccount,
            licenseType:true,
            projectPrice:null
        },
        methods: {
            checkout(subsType){
                if(this.hasAccount){
                    this.$toasted.info('You appear to already have a paid license on LEO. Please contact our team if you need support.');
                }else{
                    if (this.redirect) {
                        var period = this.subscriptionRequestedPeriod;
                        var data = {
                            'type':subsType,
                            'period': this.subscriptionRequestedPeriod,
                            'currency': this.subscriptionRequestedCurrency,
                        };
                    } else {
                        var period = (this.monthly) ? 'monthly' : 'annual';
                        var data = {
                            'type':subsType,
                            'period': period,
                            'currency': this.currency,
                        };
                    }
                    console.log(data);
                    axios.post('/subscription/session', data)
                    .then((response) =>  {
                        axios.get('/subscription/create/'+subsType+'/'+period+'/'+this.currency)
                        .then(function(response) {
                            stripe.redirectToCheckout({
                                sessionId: response.data.sessionId
                            })
                            .then(handleResult);
                        })
                        .catch(function (error) {
                            if(error.response.status && error.response.status == 401) {
                                window.location.href = '/login';
                            }else{
                                console.log(error);
                            }
                        })
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            createStripeSession(){
                axios.get('/subscription/create/'+subsType+'/'+period+'/'+this.currency)
                .then((response) =>  {
                    this.sessionId = response.data.sessionId;
                })
                .catch(function (error) {
                    console.log(error)
                })
            },
            getCurrency(){
                $.getJSON('https://ipapi.co/'+this.userIp+'/json')
                .then((response) =>  {
                    if(response.currency && (response.currency == 'GBP'||response.currency == 'EUR')){
                        this.currency = response.currency.toLowerCase();
                    }else{
                        this.currency = 'usd';
                    }
                    this.getPrice('individual');
                    this.getPrice('corporate');
                    this.getSinglePrice('project');
                    this.getSinglePrice('solo');
                    this.getSinglePrice('core');
                    this.getSinglePrice('pro');

                    if (this.redirect) {
                        this.checkout(this.subscriptionRequestedType);
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
            },
            getPrice(subsType){
                axios.get('/subscription/get/'+subsType+'/annual/'+this.currency)
                .then((response) =>  {
                    if(subsType == 'individual'){
                        this.individualPrice = response.data.price;
                    }else{
                        this.corporatePrice = response.data.price;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
            },
            getSinglePrice(subsType){
                var period = (this.monthly) ? 'monthly' : 'annual';
                axios.get('/single-payment/get/'+subsType+'/annual/'+this.currency)
                .then((response) =>  {
                    if(subsType == 'project'){
                        this.projectPrice = response.data.price;
                    }else if(subsType == 'solo'){
                        this.soloPrice = response.data.price;
                    }else if(subsType == 'core'){
                        this.corePrice = response.data.price;
                    }else if(subsType == 'pro'){
                        this.proPrice = response.data.price;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
            },
            toggleLicenseType(){
                this.licenseType = !this.licenseType;
                if(this.licenseType){
                    $('.sales-page.page-pricing .header').css({'backgroundColor':'#E26766'});
                }else{
                    $('.sales-page.page-pricing .header').css({'backgroundColor':'#5B45E0'});
                }
            }
        },
        components: {
            'ToggleButton': ToggleButton
        },
        mounted() {
            this.getCurrency();
        },
    });
}